<template>
  <page-template>
    <template slot="page-content">
      <div class="experience--template page-template page-transition z-content">
        <div class="relative">
          <div class="relative z-content pb5-ns">
            <section class="relative mw12 flex flex-row bg-beige pb6 pb0-ns">
              <!-- MOBILE {{ getUserIs21 }} -->
              <div
                class="bg-beige w-100 dn-ns mobile-exp"
                v-if="isWindowWidthMobile == true"
              >
                <div
                  class="relative acc-height"
                  :style="{ 'min-height': 68 * page.experiences.length + 'px' }"
                >
                  <div class="mobile-acc"></div>
                  <div
                    v-show="mobileActive == key"
                    v-for="(topic, key, index) in page.experiences"
                    :class="
                      'bg-cream-' +
                        topic.color_theme.bg +
                        '-split-after mobile-acc'
                    "
                  ></div>
                  <div
                    v-for="(topic, key, index) in page.experiences"
                    :class="'theme-' + topic.color_theme.main"
                    v-if="topic.is_published"
                  >
                    <div
                      v-if="topic.is_link"
                      class="mobile-info relative z-0"
                      :class="mobileActive == key"
                    >
                      <div>
                        <div
                          :id="topic.title + '-router-link'"
                          class="mobile-acc pointer absolute z-0"
                          :class="{ 'dn-important': mobileMenuOpen }"
                          :style="{ top: topIndex(key) + 'px', zIndex: 3000 }"
                        >
                          <div
                            class="flex flex-row items-center justify-between pointer mobile-title container-fluid"
                          >
                            <router-link
                              class="is-black pointer"
                              :to="topic.link"
                              :title="topic.title"
                              ><h3
                                class="f3 ttu is-tablet-bold dib relative is-beige"
                              >
                                {{ topic.title }}
                              </h3></router-link
                            >
                            <router-link
                              :to="topic.link"
                              class="w2 inline-flex pointer arrow-down-icon is-orange pointer"
                            >
                              <div
                                class="right-arrow is-cream pt1 simple-svg-wrapper"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 17.138 11.234"
                                  class="simple-svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#EEE3C6"
                                    stroke-linecap="round"
                                    stroke-width="3"
                                  >
                                    <path
                                      d="m5.462 0-5.462 4.054 5.462 4.18"
                                      stroke-linejoin="round"
                                      transform="matrix(-1 0 0 -1 15.638 9.734)"
                                    ></path>
                                    <path d="m15.638 5.576h-14.138"></path>
                                  </g>
                                </svg>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div class="relative overflow-hidden info-height">
                          <div class="info" style="display: none;"></div>
                        </div>
                      </div>
                    </div>
                    <accordion
                      v-else
                      :class="{ 'negitive-margin': mobileActive == key }"
                      :type="'mobile-info'"
                      :index="key"
                      :mobileActive.sync="mobileActive"
                      :resizing="$refs.exprow"
                    >
                      <template slot="parent-nav-link">
                        <!-- TOPIC -->
                        <h3 class="f3 ttu is-tablet-bold dib relative is-beige">
                          {{ topic.title }}
                        </h3>
                      </template>
                      <template slot="sub-nav-links">
                        <div class="z-4 relative">
                          <div class="pv5" :id="topic.slug">
                            <div v-if="topic.is_phase1" class="">
                              <div
                                class="f25px is-tablet-regular pb4 ph4-m ph6-l lh-copy container-fluid topic-copy"
                                v-html="marked(topic.description  || '')"
                              ></div>
                              <bg-vimeo-video-embed
                                v-if="topic.phase1_video_id"
                                :vimeoVideoId="topic.phase1_video_id"
                              ></bg-vimeo-video-embed>
                              <img
                                v-else
                                class="img-responsive ph4 pr0-ns"
                                :src="topic.phase1_image"
                              />
                            </div>
                            <div v-else>
                              <div
                                class="f20px is-tablet-regular pb4 ph4 lh-copy topic-copy"
                                v-html="marked(topic.description  || '')"
                              ></div>
                              <div
                                class="exp-row"
                                ref="exprow"
                                v-for="(event, eIndex) in topic.items"
                                @mouseover="desktopActive2 = eIndex"
                                :class="{
                                  colorActive: desktopActive2 == eIndex
                                }"
                              >
                                <transition
                                  @beforeEnter="beforeEnter2"
                                  @enter="enter2"
                                  @leave="leave2"
                                >
                                  <div
                                    class="relative pa4 w-100"
                                    v-show="desktopActive2 !== eIndex"
                                  >
                                    <div class="row middle-sm">
                                      <div class="col-xs-12 col-sm-6 pv4">
                                        <img
                                          class="db relative center w-100"
                                          :src="event.image"
                                        />
                                      </div>
                                      <div class="col-xs-12 col-sm-6">
                                        <h4
                                          class="f3 is-tablet-wide-bold pb2 is-navy"
                                          :ref="event.title"
                                        >
                                          {{ event.title }}
                                        </h4>
                                        <div
                                          v-if="event.text"
                                          class="f15px is-tablet-regular pb3 lh-copy"
                                          v-html="marked(event.text  || '')"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </transition>
                                <transition
                                  @beforeEnter="beforeEnter"
                                  @enter="enter"
                                  @leave="leave"
                                >
                                  <div
                                    class="pa4 w-100"
                                    v-show="desktopActive2 == eIndex"
                                  >
                                    <div class="row middle-sm">
                                      <div class="col-xs-12 col-sm-6">
                                        <img
                                          class="db relative center w-100"
                                          :src="event.image"
                                        />
                                      </div>
                                      <div
                                        class="col-xs-12 col-sm-6 mt3 cms-content is-experience"
                                      >
                                        <h4
                                          class="f-2 is-tablet-wide-bold pb2 is-beige"
                                          :ref="event.title"
                                        >
                                          {{ event.title }}
                                        </h4>
                                        <div
                                          v-if="event.text"
                                          class="f15px is-tablet-regular pb3 lh-copy is-beige"
                                          v-html="marked(event.text  || '')"
                                        ></div>
                                        <a
                                          v-if="event.link"
                                          class="f15px is-tablet-bold pb4 lh-20px ttu is-tablet-regular is-yellow"
                                          :title="'Check Out ' + event.title"
                                          :href="event.link"
                                          >{{ event.cta
                                          }}<simple-svg
                                            class="checkout is-yellow"
                                            :filepath="
                                              '/uploads/checkout-arrow.svg'
                                            "
                                          ></simple-svg
                                        ></a>
                                      </div>
                                    </div>
                                  </div>
                                </transition>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </accordion>
                  </div>
                </div>
              </div>

              <!-- DESKTOP -->
              <div
                class="dn relative flex-ns flex-grow-1"
                v-if="isWindowWidthMobile == false"
              >
                <div class="mw6 w-100 bg-beige pv5 pl5">
                  <div class="h-100 z-4 relative">
                    <div class="info-bg sticky-nav">
                      <div class="pr3">
                        <!-- PAGE NAME -->
                        <div
                          class=""
                          v-for="(topic, index, key) in page.experiences"
                          v-if="topic.is_published"
                        >
                          <accordion
                            v-if="topic.is_link"
                            :index="key"
                            :desktopActive.sync="desktopActive"
                            :desktopActive2.sync="desktopActive2"
                            :link="topic.slug"
                          >
                            <template slot="parent-nav-link">
                              <!-- TOPIC -->
                              <router-link
                                class="relative flex flex-row items-center w6 h3 pv2 mb1 pl3 select-hover-dt"
                                :to="topic.link"
                              >
                                <h3
                                  :class="{
                                    active:
                                      $route.name == topic.slug ||
                                      (desktopActive == key &&
                                        $route.name == 'experience')
                                  }"
                                  class="f3 is-tablet-bold ttu txt-color"
                                >
                                  {{ topic.title }}
                                </h3>
                              </router-link>
                            </template>
                          </accordion>
                          <accordion
                            v-else
                            :index="key"
                            :desktopActive.sync="desktopActive"
                            :desktopActive2.sync="desktopActive2"
                            :link="topic.slug"
                          >
                            <template slot="parent-nav-link">
                              <!-- TOPIC -->
                              <router-link
                                v-if="index === 1 && isExpFoodRoute"
                                class="relative flex flex-row items-center w6 h3 pv2 mb1 pl3 select-hover-dt is-active"
                                :to="'/experience/' + topic.slug + '/'"
                              >
                                <h3
                                  :class="{
                                    active:
                                      $route.name == topic.slug ||
                                      (desktopActive == key &&
                                        $route.name == 'experience')
                                  }"
                                  class="f3 is-tablet-bold ttu txt-color"
                                >
                                  {{ topic.title }}
                                </h3>
                              </router-link>
                              <router-link
                                v-else
                                class="relative flex flex-row items-center w6 h3 pv2 mb1 pl3 select-hover-dt"
                                :to="'/experience/' + topic.slug + '/'"
                              >
                                <h3
                                  :class="{
                                    active:
                                      $route.name == topic.slug ||
                                      (desktopActive == key &&
                                        $route.name == 'experience')
                                  }"
                                  class="f3 is-tablet-bold ttu txt-color"
                                >
                                  {{ topic.title }}
                                </h3>
                              </router-link>
                            </template>
                          </accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="w-100 is-black bg-beige"
                  v-for="(topic, key) in page.experiences"
                  v-show="
                    $route.name == topic.slug ||
                      (desktopActive == key && $route.name == 'experience')
                  "
                  v-if="topic.is_published"
                >
                  <div
                    :class="'bg-cream-' + topic.color_theme.bg + '-split-after'"
                  >
                    <img class="rays-bg" src="/uploads/splash-rays.svg" />
                  </div>
                  <div v-if="topic.is_link" class=""></div>
                  <div v-else class="">
                    <div
                      class="z-4 relative"
                      :class="'theme-' + topic.color_theme.main"
                    >
                      <div
                        :class="'b--' + topic.color_theme.main"
                        class="mv5"
                        :id="topic.slug"
                      >
                        <div v-if="topic.is_phase1" class="relative">
                          <div
                            class="f4 is-tablet-regular pb4 lh-copy topic-copy"
                            v-html="marked(topic.description || '')"
                          ></div>
                          <bg-vimeo-video-embed
                            v-if="topic.phase1_video_id"
                            class="mr0 mr6-ns"
                            :vimeoVideoId="topic.phase1_video_id"
                          ></bg-vimeo-video-embed>
                          <img
                            v-else
                            class="img-responsive absolute left-0 pr4-ns"
                            v-lazy="topic.phase1_image"
                            :alt="topic.title"
                          />
                        </div>
                        <div v-else>
                          <div
                            class="f4 is-tablet-regular pb4 lh-copy topic-copy"
                            v-html="marked(topic.description || '')"
                          ></div>
                          <div
                            class="exp-row"
                            ref="exprow"
                            v-for="(event, eIndex) in topic.items"
                            @mouseover="desktopActive2 = eIndex"
                            :class="{ colorActive: desktopActive2 == eIndex }"
                          >
                            <transition
                              @beforeEnter="beforeEnter2"
                              @enter="enter2"
                              @leave="leave2"
                            >
                              <div
                                class="relative pa4 w-100"
                                v-show="desktopActive2 !== eIndex"
                              >
                                <div class="row middle-sm">
                                  <div class="col-xs-12 col-sm-6 pv4">
                                    <img
                                      class="db relative center w-100 mw6"
                                      :src="event.image"
                                    />
                                  </div>
                                  <div class="col-xs-12 col-sm-6">
                                    <h4
                                      class="f3 is-tablet-wide-bold pb2 is-navy"
                                      :ref="event.title"
                                    >
                                      {{ event.title }}
                                    </h4>
                                    <div
                                      v-if="event.text"
                                      class="f15px is-tablet-regular pb3 lh-copy"
                                      v-html="marked(event.text || '')"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </transition>
                            <transition
                              @beforeEnter="beforeEnter"
                              @enter="enter"
                              @leave="leave"
                            >
                              <div
                                class="pa4 w-100"
                                v-show="desktopActive2 == eIndex"
                              >
                                <div class="row middle-sm">
                                  <div class="col-xs-12 col-sm-6">
                                    <img
                                      class="db relative center w-100 mw6"
                                      :src="event.image"
                                    />
                                  </div>
                                  <div
                                    class="col-xs-12 col-sm-6 cms-content is-experience"
                                  >
                                    <h4
                                      class="f-2 is-tablet-wide-bold pb2 is-beige"
                                      :ref="event.title"
                                    >
                                      {{ event.title }}
                                    </h4>
                                    <div
                                      v-if="event.text"
                                      class="f15px is-tablet-regular pb3 lh-copy is-beige"
                                      v-html="marked(event.text || '')"
                                    ></div>
                                    <a
                                      v-if="event.link"
                                      class="f15px is-tablet-bold pb4 lh-20px ttu is-tablet-regular is-yellow"
                                      :title="'Check Out ' + event.title"
                                      :href="event.link"
                                      >{{ event.cta
                                      }}<simple-svg
                                        class="checkout is-yellow"
                                        :filepath="
                                          '/uploads/checkout-arrow.svg'
                                        "
                                      ></simple-svg
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </transition>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div
          class="fixed top-0 left-0 right-0 bottom-0 bg-black-70"
          style="z-index: 100000"
          v-show="showGrassLandsModal"
        >
          <div class="db center w-100">
            <div
              class="db absolute w-100 abs-vert-center left-0 right-0 center relative mt5"
            >
              <section class="relative mw7 center tc">
                <h3 class="f3 mv3 is-lorano-bold is-white">
                  Welcome to Grass Lands
                </h3>
                <div class="" v-show="!showNot21Message">
                  <h3 class="f4 mv3 is-lorano-bold is-white">
                    Are you at least 21 years of age or older?
                  </h3>
                  <div
                    class="flex flex-row items-center justify-center relative center mv3 "
                  >
                    <a
                      title="Yes"
                      id="ol20-gl-yes"
                      class="db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer"
                      @click="userIs21Method()"
                    >
                      <span class="text">
                        Yes
                      </span>
                    </a>
                    <a
                      title="No"
                      id="ol20-gl-no"
                      class="db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer"
                      @click="
                        userIsNot21Method();
                        showNot21MessageMethod();
                      "
                    >
                      <span class="text">
                        No
                      </span>
                    </a>
                  </div>
                </div>
                <div class="relative center mv3 tc" v-show="showNot21Message">
                  <h3 class="f4 mv3 is-lorano-bold is-white">
                    Sorry! You need to be of legal age to visit.
                  </h3>
                  <router-link
                    title="Go Home"
                    id="ol19-tickets-single-day-gold"
                    class="db relative w-100 mw5 center pv3 btn-generic has-orange-bg overflow-hidden link pointer"
                    to="/"
                  >
                    <span class="text">
                      Go Home
                    </span>
                  </router-link>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import Accordion from "./accordion.vue";
import PageTemplate from "./page-template.vue";
import Velocity from "velocity-animate";
import BgVimeoVideoEmbed from "./bg-vimeo-video-embed.vue";
export default {
  components: {
    Accordion,
    PageTemplate,
    BgVimeoVideoEmbed
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: titleChunk => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.page.seo_description
        }
      ]
    };
  },
  data() {
    return {
      appIsLoaded: true,
      logoIsLoaded: true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
      desktopActive: 0,
      desktopActive2: -1,
      mobileActive: -1,
      currentActive: null,
      parallax: null,
      parallax2: true,
      showGrassLandsModal: false,
      showNot21Message: false,
      isExpFoodRoute: false,
      mobileMenuOpen: false
    };
  },
  computed: {
    page: function() {
      var pageData = this.$store.getters.filterPagesByName(
        this.pageMarkdownFileName
      );
      //console.log(pageData[0]);
      return pageData[0];
    },
    getUserIs21: function() {
      return this.$store.getters.getUserIs21;
    }
  },
  methods: {
    userIs21Method() {
      this.$store.dispatch("userIs21", "payload 21");
      this.showGrassLandsModal = false;
    },
    userIsNot21Method() {
      this.$store.dispatch("userIsNot21", "payload Not 21");
    },
    showNot21MessageMethod() {
      this.showNot21Message = true;
    },
    scrollMeTo(refName) {
      var el = this.$refs[refName][0];
      var top = window.pageYOffset + el.getBoundingClientRect().top - 70;
      window.scrollTo(0, top);
    },
    pageLoad() {
      this.windowSize();
      this.scrollParallax();
      this.contentHeight();
    },
    resizing() {
      this.windowSize();
      this.scrollParallax();
      this.contentHeight();
    },
    windowSize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
        this.mobileActive = -1;
      }
    },
    topIndex(index) {
      //console.log('topIndex', index);
      return 68 * index;
    },
    top(index) {
      //console.log('top');
      /*
        var self = this;
        self.active = false;
        setTimeout(function(){
          self.removeActive = false;
        },1);
        */
      //return 'top:'+(index * 68)+'px';
      /*
        if(this.mobileActive < 0){

        } else if(this.mobileActive == index){
          setTimeout(function(){
            self.active = true;
            self.removeActive = true;
          }, 400);
          return 'top:0px;z-index:10;';
        } else {
          self.active = false;
          return 'top:0px;';
        }
        */
    },
    contentHeight() {
      this.$refs.exprow.map(function(value, key) {
        var height = value.children[0].getBoundingClientRect().height;
        if (height == 0)
          height = value.children[1].getBoundingClientRect().height;
        value.style.height = height + "px";
      });
    },
    calcParallax: function(myTarget, offset, movement, positioning) {
      if (this.$refs[myTarget]) {
        this.parallax2 = false;
        if (
          this.$refs[myTarget].parentElement.getBoundingClientRect().y +
            offset +
            this.$refs[myTarget].getBoundingClientRect().height +
            movement >
            0 &&
          this.$refs[myTarget].parentElement.getBoundingClientRect().y +
            offset -
            movement <
            window.innerHeight
        ) {
          var newMovement =
            offset +
            ((this.$refs[myTarget].parentElement.getBoundingClientRect().y +
              offset +
              this.$refs[myTarget].getBoundingClientRect().height / 2 -
              window.innerHeight / 2 -
              27) /
              window.innerHeight) *
              movement;
          return "top:" + newMovement + "px;" + positioning;
        } else {
          return "display:none;";
        }
      }
    },
    scrollParallax: function() {
      // console.log(window.scrollY);
      this.parallax = window.scrollY;
    },
    beforeEnter(el) {
      el.style.height = "0px";
      el.style.top = "25px";
    },
    enter(el, done) {
      el.style.height = "auto";
      var height = el.getBoundingClientRect().height;
      // this.currentActive = el.parentElement;
      // el.parentElement.style.height = height + 'px';
      Velocity(el.parentElement, "stop");
      Velocity(
        el.parentElement,
        {
          height
        },
        {
          duration: 200,
          complete: done
        },
        {
          loop: true
        }
      );
      Velocity(el, "stop");
      Velocity(
        el,
        {
          top: "0px"
        },
        {
          duration: 200,
          complete: done
        },
        {
          loop: true
        }
      );
    },
    leave(el, done) {
      el.style.height = "0px";
    },
    beforeEnter2(el) {
      el.style.height = "0px";
      // el.style.top = '50px';
    },
    enter2(el, done) {
      el.style.height = "auto";
      var height = el.getBoundingClientRect().height;
      // el.parentElement.style.height = height + 'px';
      Velocity(el.parentElement, "stop");
      Velocity(
        el.parentElement,
        {
          height
        },
        {
          duration: 200,
          complete: done
        },
        {
          loop: true
        }
      );
      Velocity(el, "stop");
      Velocity(
        el,
        {
          top: "0px"
        },
        {
          duration: 200,
          complete: done
        },
        {
          loop: true
        }
      );
    },
    leave2(el, done) {
      el.style.height = "0px";
    }
  },
  created() {
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
    if (this.window.width < 768) this.isWindowWidthMobile = true;
    else this.isWindowWidthMobile = false;
    this.desktopActive2 = 0;
    window.addEventListener("resize", this.resizing);
    window.addEventListener("load", this.pageLoad);
    window.addEventListener("scroll", this.scrollParallax);
    /* Grass Lands Modal Gate */
    //Mobile
    if (this.isWindowWidthMobile) {
      if (this.mobileActive == 3 && this.getUserIs21 == false) {
        this.showGrassLandsModal = true;
      } else {
        this.showGrassLandsModal = false;
      }
    }
    //Desktop
    else {
      if (
        this.$route.path === "/experience/grass-lands/" &&
        this.getUserIs21 == false
      ) {
        //console.log('mounted 1.1 - ', this.showGrassLandsModal)
        this.showGrassLandsModal = true;
      } else {
        this.showGrassLandsModal = false;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizing);
    window.removeEventListener("load", this.pageLoad);
    window.removeEventListener("scroll", this.scrollParallax);
  },
  beforeMount() {
    //
  },
  mounted() {
    this.windowSize();
    this.desktopActive2 = 0;
    setInterval(() => {
      if (this.parallax2 !== false) this.parallax = this.parallax + 0.02;
    }),
      10;
    // anchor links
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace("#", "");
        document.getElementById(element).scrollIntoView();
      }, 300);
    } else {
      //console.log('else', this.$route.path );
    }
    if (this.isWindowWidthMobile) {
      //console.log('windowWidthMobile - ', this.$route.path, this.mobileActive);
      if (
        this.$route.path === "/experience/food-and-drink/" ||
        this.$route.path === "/experience/food-and-drink"
      ) {
        this.mobileActive = 0;
      } else if (
        this.$route.path === "/experience/comedy-and-talks/" ||
        this.$route.path === "/experience/comedy-and-talks"
      ) {
        this.mobileActive = 1;
      } else if (
        this.$route.path === "/experience/gastromagic/" ||
        this.$route.path === "/experience/gastromagic"
      ) {
        this.mobileActive = 2;
      } else if (
        this.$route.path === "/experience/grass-lands/" ||
        this.$route.path === "/experience/grass-lands"
      ) {
        this.mobileActive = 3;
      } else if (
        this.$route.path === "/experience/art/" ||
        this.$route.path === "/experience/art"
      ) {
        this.mobileActive = 4;
      } else if (
        this.$route.path === "/experience/sustainability/" ||
        this.$route.path === "/experience/sustainability"
      ) {
        this.mobileActive = 5;
      } else if (
        this.$route.path === "/experience/shopping/" ||
        this.$route.path === "/experience/shopping"
      ) {
        this.mobileActive = 7;
      } else if (
        this.$route.path === "/experience/more-activities/" ||
        this.$route.path === "/experience/more-activities"
      ) {
        this.mobileActive = 8;
      } else {
        this.mobileActive = -1;
      }
    } else {
      if (
        this.$route.path === "/experience/" ||
        this.$route.path === "/experience"
      ) {
        this.isExpFoodRoute = true;
        this.desktopActive = 1;
      } else if (
        this.$route.path === "/experience/food-and-drink/" ||
        this.$route.path === "/experience/food-and-drink"
      ) {
        this.isExpFoodRoute = true;
      } else {
        this.isExpFoodRoute = false;
      }
    }
    /* mobile accordion menu nav link behavior */
    if (this.mobileActive === -1) {
      this.mobileMenuOpen = false;
    } else {
      this.mobileMenuOpen = true;
    }
    //console.log('mounted - mobileMenuOpen:', this.mobileActive, this.mobileMenuOpen);
    this.$nextTick(() => {
      //
    });
  },
  updated() {
    /* mobile accordion menu nav link behavior */
    if (this.mobileActive !== -1) {
      this.mobileMenuOpen = true;
    } else {
      this.mobileMenuOpen = false;
    }
    //console.log('update - mobileMenuOpen:', this.mobileActive, this.mobileMenuOpen);

    /* Grass Lands Modal Gate */
    //Mobile
    if (this.isWindowWidthMobile) {
      if (this.mobileActive == 3 && this.getUserIs21 == false) {
        this.showGrassLandsModal = true;
      } else {
        this.showGrassLandsModal = false;
      }
    }
    //Desktop
    else {
      if (
        this.$route.path === "/experience/grass-lands/" &&
        this.getUserIs21 == false
      ) {
        //console.log('updated 1.1 - ', this.showGrassLandsModal)
        this.showGrassLandsModal = true;
      } else {
        this.showGrassLandsModal = false;
      }
    }
  },
  beforeDestroy() {
    //
  }
};
</script>
